import flatpickr from "flatpickr";

export function renderCalendar(trans, options = {}, callback = null, customId = "#calendar", customLabel = "common.date") {
  let label = document.createElement(`label`);
  label.setAttribute("for", customId);
  label.textContent = trans(customLabel);
  label.style.marginTop = "20px";

  let elInput = null;
  if (options["inline"] === false) {
    let calendarInputNoInline = document.createElement("input");
    calendarInputNoInline.id = `calendar-input-${customId}`;
    document.querySelector(customId).after(calendarInputNoInline);
    elInput = calendarInputNoInline;
  }

  let configs = {
    minDate: "today",
    inline: true,
    onChange: callback,
    ...options,
  };

  document.querySelector(customId).before(label);

  flatpickr(elInput ? elInput : customId, configs);
}
